export const SETTING_PURCHASE_PRICE_SOURCE_VALUES = {
  MANUAL: 'manual',
  VENDOR_PRICE: 'vendor_price'
}

export const SETTING_RETAIL_PRINTER_TYPE_VALUES = {
  NONE: 'none',
  FISCAL_PRINTER: 'fiscal_printer',
  THERMAL_PRINTER: 'thermal_printer'
}
